import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UrlStore} from '../../../shared/url-store';
import {AppConfiguration} from '../../models/config';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    private static readonly GROUP_SALES_ROLE = 'GroupSales';
    private static readonly GROUP_SALES_SCREEN_ID = 'group-sales';

    private appConfig: AppConfiguration;

    constructor(private http: HttpClient) {
    }

    public getAppConfig(): Observable<AppConfiguration> {
        return this.http.get<AppConfiguration>(`${UrlStore.api.config}/app`);
    }

    public getAppConfigObject(): AppConfiguration {
        if (!this.appConfig) {
            this.appConfig = JSON.parse(localStorage.getItem('appConfig'));
        }
        return this.appConfig;
    }

    public getConfig(): Observable<any> {
        return this.http.get(UrlStore.api.config);
    }

    public getComponentConfiguration(screenName: string, componentId: string): any {
        if (this.appConfig.hasOwnProperty(screenName)) {
            return this.appConfig[screenName].components.find(comp => comp.id === componentId);
        }
        return null;
    }

    /**
     * Screens missing from screen_config are disabled by default (fail closed) -
     * a screen only renders when the config explicitly says is_enabled: true.
     * A GroupSales-role user is restricted to only the group-sales screen,
     * regardless of what screen_config says for the rest.
     */
    public isScreenEnabled(screenId: string): boolean {
        if (this.isGroupSalesOnlyRole()) {
            return screenId === ConfigService.GROUP_SALES_SCREEN_ID;
        }
        const appConfig = this.getAppConfigObject();
        return !!appConfig && appConfig.hasOwnProperty(screenId) && appConfig[screenId].is_enabled === true;
    }

    public getUserRole(): string {
        const userConfig = JSON.parse(localStorage.getItem('userConfig'));
        return userConfig ? userConfig.userRole : null;
    }

    public isGroupSalesOnlyRole(): boolean {
        return this.getUserRole() === ConfigService.GROUP_SALES_ROLE;
    }

    public refreshAppConfig(): void {
        this.getAppConfig().subscribe(config => {
            this.appConfig = config;
            localStorage.setItem('appConfig', JSON.stringify(config));
        });
    }
}
